import { useNavigate } from "react-router-dom";
import {
  ArrowBack,
} from "@mui/icons-material";
import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const About = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const rawTitle = t("aboutus.about.title");
  const plainTitle = rawTitle.replace(/<\/?[^>]+(>|$)/g, "");

  return (
    <Box pb={10}>
      {mobileView && (
        <>
          <Grid container justify="center"  pb={3}>
            {/* <Grid item xs={4}>
              <IconButton onClick={() => navigate(-1)}>
                <ArrowBack />
              </IconButton>
            </Grid>
            <Grid item xs={4} alignSelf="center">
              <Typography
                textAlign="center"
                fontWeight={600}
                color={theme.palette.primary.main}
              >
                {plainTitle}
              </Typography>
            </Grid> */}
          </Grid>
        </>
      )}
      <>
        <Container mt={mobileView ? 0 : null}>
          <Box py={!mobileView && 4}>
            {/* About us */}
            <Typography
              variant="h1"
              component="h1"
              fontWeight={800}
              fontSize="20px"
              color={theme.palette.primary.main}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.title") }}
            >
            </Typography>
            <Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.firstdesc") }}>
            </Typography><br/>
            <Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.seconddesc") }}>
            </Typography>
            <Typography variant="h2" fontSize="14px" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.firstsubtitle") }}>
            </Typography>
            <Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.thirddesc") }}>
            </Typography>
            <Typography variant="h2" fontSize="14px" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.secondsubtitle") }}>
            </Typography>
<Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.fourthdesc") }}>
            </Typography>
<Typography variant="h2" fontSize="14px" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.thirdsubtitle") }}>
            </Typography>
<Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.fifthdesc") }}>
            </Typography>
<Typography variant="h2" fontSize="14px" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.fourthsubtitle") }}>
            </Typography>
<Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.sixthdesc") }}>
            </Typography>
<Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.seventhdesc") }}>
            </Typography>
<Typography variant="h2" fontSize="14px" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.sixthsubtitle") }}>
            </Typography>
<Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.eighthdesc") }}>
            </Typography>
            <Typography variant="h2" fontSize="14px" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.seventhsubtitle") }}>
            </Typography>
            <Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.ninthdesc") }}>
            </Typography><br/>
<Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.tenthdesc") }}>
            </Typography><br/>
<Typography variant="body2" component="div" sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
              dangerouslySetInnerHTML={{ __html: t("aboutus.about.eleventhdesc") }}>
            </Typography>
          </Box>
        </Container>
      </>
    </Box>
  );
};

export default About;
